import { connect } from 'react-redux'
import { isOffline } from 'redux-offline-status'
import { getFromSettings, getFromFeatures } from 'src/utils/helpers'
import { resetClaims, getDateTimeDisplay, setDisclaimer } from './actions'
import { getWeather } from './Weather/actions'
import { setDateAndTime } from './TimeAndDate/actions'

import Claims from './Claims'

const mapDispatchToProps = {
  resetClaims,
  getWeather,
  setDisclaimer,
  setDateAndTime,
}

const mapStateToProps = state => {
  return {
    isOffline: isOffline(state),
    vehicleCompleted: state.vehicles.stepCompleted,
    vehicle: state.vehicles.vehicle,
    timeAndDateCompleted: state.dateAndTime.stepCompleted,
    date: state.dateAndTime.date,
    time: state.dateAndTime.time,
    dateTimeDisplay: getDateTimeDisplay(state.dateAndTime.date, state.dateAndTime.time),
    locationCompleted: state.claimLocation.stepCompleted,
    claimLocation: state.claimLocation.claimLocation,
    savedDate: state.weather.savedDate,
    weatherDescription: state.weather.description,
    weatherCompleted: state.weather.stepCompleted,
    driversCompleted: state.drivers.stepCompleted,
    pictures: state.pictures.pictures,
    driver: state.drivers.driver,
    damageType: state.whatHappened.type,
    whatHappenedCompleted: state.whatHappened.stepCompleted,
    vehicleAndDriver: state.vehicleAndDriver.vehicleAndDriver,
    vehicleAndDriverCompleted: state.vehicleAndDriver.stepCompleted,
    officer: state.investigatingOfficer.officer,
    officerCompleted: state.investigatingOfficer.stepCompleted,
    passengerCompleted: state.passenger.stepCompleted,
    passenger: state.passenger.passenger,
    witnessCompleted: state.witness.stepCompleted,
    witness: state.witness.witness,
    noteCompleted: state.note.stepCompleted,
    note: state.note.note,
    labels: getFromSettings(state, 'labels', {}),
    claimSettings: getFromFeatures(state, 'reportClaim', 'settings', {}),
    showDisclaimer: state.claims.showDisclaimer,
    features: state.appReducer.features,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Claims)
